import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/HeaderSection.css";
import heroImage from "../assets/ai-marketing-hero.png"; // <- Use a new image!

const HeaderSection = () => {

    // Scroll to the Products section
    const scrollToProducts = () => {
        const section = document.getElementById("what-we-automate");
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <header className="header-section">
            {/* Animated Background */}
            <div className="animated-background"></div>

            {/* Content */}
            <div className="header-content">
                <div className="header-text">
                    <h1>
                        <span className="highlight">Automate Smarter.</span><br />
                        <span className="highlight">Grow Faster.</span>
                    </h1>
                    <p className="subtext">
                        We design custom AI workflows that save you hours, scale your outreach, and turn manual work into automated growth.
                    </p>
                    <div className="cta-buttons">
                        {/* Book a Free Automation Call button redirects to /contact */}
                        <NavLink to="/contact" className="cta-button primary">
                            Book a Free Automation Call
                        </NavLink>

                        <span className="or-separator">or</span>

                        {/* See what automations we build button scrolls to #what-we-automate */}
                        <button className="cta-button secondary" onClick={scrollToProducts}>
                            See what automations we build →
                        </button>
                    </div>
                </div>

                {/* Hero Image */}
                <div className="header-screenshot">
                    <img src={heroImage} alt="AI-powered business automation interface" className="screenshot" />
                </div>
            </div>
        </header>
    );
};

export default HeaderSection;
